"use client";
"use client";
import React, { useState, useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import AdminBar from '../AdminBar';
import AdSlotWrapper from '../AdSlotWrapper';
import LegacySiteFrame from './LegacySiteFrame';

const MainLayout = ({ children, settings = {}, articles = [], pages = [], categories = [] }) => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem('surgedome_current_user'));
      setIsAdmin(user?.role === 'super_admin');
    } catch (e) { console.error("Error in MainLayout.jsx:", e); }
  }, []);

  return (
    <div className={`w-full min-h-screen bg-brand-surface-alt relative ${isAdmin ? 'pt-10' : ''}`}>
      {/* Global Skin Ad Background */}
      <div className="fixed inset-0 z-0 flex justify-center pointer-events-none overflow-hidden">
         <div className="w-full h-full pointer-events-auto">
            <AdSlotWrapper id="global_skin_ad" className="w-full h-full object-cover flex items-center justify-center text-brand-muted font-bold text-2xl" settings={settings} />
         </div>
      </div>

      <AdminBar />
      
      {/* Main Centered Site Container */}
      <LegacySiteFrame>
        <div className="w-full">
          <AdSlotWrapper id="global_top_banner" settings={settings} />
        </div>
        <Header siteSettings={settings} articles={articles} categories={categories} pages={pages} />
        <main className="flex-grow w-full relative px-4 md:px-8 py-8">
          {children}
        </main>
        
        <Footer siteSettings={settings} pages={pages} categories={categories} />
      </LegacySiteFrame>
    </div>
  );
};

export default MainLayout;
